export function splitString(str: string, chunkSize: number) {
  const result: string[] = []
  for (let i = 0; i < str.length; i += chunkSize) {
    result.push(str.slice(i, i + chunkSize))
  }
  return result
}
